export const COMM_LABEL = {
  registration_received: "Registration Received",
  interview_invitation: "Interview Invitation",
  digital_onboarding: "Digital Onboarding",
};

export const ONB_EVENT_LABEL = {
  onboarding_started: "Onboarding started",
  onboarding_resent: "Onboarding link resent",
};

export function fmtWhen(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "2-digit", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
